import React, { useEffect, useState } from 'react';
import { getToken } from '../utils/cookieUtils';
import LoggedNav from "../components/LoggedNav";
import Nav from "../components/Nav";
import SubscriptionSummary from "../components/SubscriptionSummary"; // Assuming this is the correct import for the SubscriptionPlans component

function SubscriptionSummaryComponent(props) {
  return (
    <>
      {getToken() ? <LoggedNav customer={props.customer} /> : <Nav customer={props.customer} />}
 
      <SubscriptionSummary /> 
    </>
  );
}

export default SubscriptionSummaryComponent;